/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-array-index-key */

import CommentsSection from '../../common/CommentsSection';

const FFIEC041Comment = ({
    getFFIEC041User, ffiec041Comment, setFFIEC041Comment, commentLoading, addFFIEC041Comment,
    loading, getUserCommentsForFFIEC041, ffiec041Edit, handleFFIEC041Click, ffiec041Show,
    ffiec041Target, onFFIEC041EditClick, onFFIEC041ClickDelete, ffiec041SelectedIndex,
    ffiec041SelectedComment, setFFIEC041SelectedComment, onFFIEC041CancelClick, onFFIEC041ClickSave,
}) => (
    <CommentsSection
        getUser={getFFIEC041User}
        comment={ffiec041Comment}
        setComment={setFFIEC041Comment}
        commentLoading={commentLoading}
        addComment={addFFIEC041Comment}
        loading={loading}
        getUserComments={getUserCommentsForFFIEC041}
        edit={ffiec041Edit}
        handleClick={handleFFIEC041Click}
        show={ffiec041Show}
        target={ffiec041Target}
        onEditClick={onFFIEC041EditClick}
        onClickDelete={onFFIEC041ClickDelete}
        selectedIndex={ffiec041SelectedIndex}
        selectedComment={ffiec041SelectedComment}
        setSelectedComment={setFFIEC041SelectedComment}
        onCancelClick={onFFIEC041CancelClick}
        onClickSave={onFFIEC041ClickSave}
    />
);

export default FFIEC041Comment;
